import React, { useRef, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { DangerButton, InfoButton, SuccessButton, WarningButton } from "../../../../ui/buttons/Button";
import { Dimmer } from "../../../spinner";
import { Mensaje } from "../../../mensajes2";
import moment from "moment";


export default function ActualizarPeriodoNomina(props) {

    const [periodos, setPeriodos] = useState([]);

    const [filterFn, setFilterFn] = useState({ fn: (items) => { return items; }, });
    const [activate, setActivate] = useState(false);
    const [activo, setActivo] = useState(true);

    const [itemSelect, setItemSelect] = useState(-1);
    const [mensaje, setMensaje] = useState({
        mostrar: false,
        titulo: "",
        texto: "",
        icono: "",
    });

    const txtNumPeriodo = useRef();
    const txtFechaIni = useRef();
    const txtFechaFin = useRef();
    const btnAcepta = useRef();
    const btnCancela = useRef();


    const salir = () => {
        blanquear();
        props.onHideCancela();
    };

    const aceptar = () => {
        var sigue = true;
        props.onHideAcepta(parseInt(txtNumPeriodo.current.value), txtFechaIni.current.value, txtFechaFin.current.value);
    };



    const cerrarModal = () => {
        setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
        props.onHideCancela();
        props.onHideRenderizar()
    };

    const blanquear = () => {
        setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' })
        
    };

    return (
        <Modal
            size="md"
            {...props}
            aria-labelledby="contained-modal-title-vcenter"
            centered
            style={{ backgroundColor: "rgb(0,0,0,0.5)" }}
            backdrop="static"
            keyboard={false}
            onShow={() => {
                txtNumPeriodo.current.value = props.periodo.numper;
                txtFechaIni.current.value = moment.utc(props.periodo.fecini).format("YYYY-MM-DD")
                txtFechaFin.current.value = moment.utc(props.periodo.fecfin).format("YYYY-MM-DD")
            }}
        >
            <Modal.Header className="col-12 m-0 px-4 py-2 d-flex justify-content-between azulGradiant text-light rounded-top azulGradiant">
                <h3 className="fw-bold m-0">Actulizar Tipos de Nomina</h3>
                <a type="button" className="fw-bold text-light fs-6" onClick={salir}>
                    Salir <i className="fa fa-times ms-2"></i>
                </a>
            </Modal.Header>
            <Modal.Body className="col-12 row mx-auto m-0 p-2">
                <div class="input-group input-group-sm mb-1 col-md-4">
                    <span class="input-group-text" id="inputGroup-sizing-sm">Periodo:</span>
                    <input type="text" ref={txtNumPeriodo} readOnly class="form-control text-uppercase" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" />
                </div>
                <div class="input-group input-group-sm mb-1 col-md-8"></div>
                <div class="input-group input-group-sm mb-1 col-md-6">
                    <span class="input-group-text" id="inputGroup-sizing-sm">Fecha Inicio:</span>
                    <input type="date" ref={txtFechaIni} readOnly={props.operacion === 4 ? true : false} class="form-control text-uppercase" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm"/>
                </div>

                <div class="input-group input-group-sm mb-1 col-md-6">
                    <span class="input-group-text" id="inputGroup-sizing-sm">Fecha Fin:</span>
                    <input type="date" ref={txtFechaFin} readOnly={props.operacion === 4 ? true : false} class="form-control text-uppercase" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm"/>
                </div>



            </Modal.Body>
            <Modal.Footer>
                <SuccessButton disabled={props.operacion !== 4 ? false : true} ref={btnAcepta} onClick={aceptar}>Aceptar</SuccessButton>
                <DangerButton ref={btnCancela} onClick={salir}>Cancelar</DangerButton>
            </Modal.Footer>
            <Dimmer active={activate} inverted>
            </Dimmer>
            <Mensaje
                mensaje={mensaje}
                onHide={() => {
                    mensaje.titulo === "Exito."
                        ? cerrarModal()
                        : setMensaje({
                            mostrar: false,
                            titulo: "",
                            texto: "",
                            icono: "",
                        });
                }}
            />
        </Modal>
    );
}
